import { Toaster as SonnerToaster } from 'sonner';

const Toaster = () => (
  <SonnerToaster
    position="top-center"
    toastOptions={{
      className: 'text-sm',
      style: {
        borderRadius: '0.375rem',
      },
    }}
  />
);

export { Toaster };
